<template>
	<section class="section">
		<h1 class="title">Categories</h1>
		<ul>
			<li>
				<a href="/#/categories/all">All Recipes</a> ({{ total }})
			</li>
			<li v-for="category in categories"
					v-bind:key="category.key">
				<a v-bind:href="'/#/categories/' + category.key">
					{{ category.key }}
				</a> ({{ category.value }})
			</li>
		</ul>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		data: function () {
			return {
				categories: [],
				total: 0
			}
		},
		created: function() {
			var vm = this

			db.query( 'recipes/categories', {
				group: true,
			}).then( function( res ) {
				console.log( res )
				vm.categories = res.rows
				
				vm.total = 0
				for( var idx in res.rows )
				{
					vm.total += res.rows[idx].value
				}

			}).catch( function( err ) {
				throw err
			})
		}
	}
</script>
